module.exports = __webpack_public_path__ + "img/260px-Joast_(Justus)_Hiddes_Halbertsma.70b2828b.jpg";